/* KOR-E Upsell — AJAX add-to-cart + progress bar */
(function () {
  'use strict';

  // AJAX add-to-cart for all .kore-upsell-add buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.kore-upsell-add');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('kore-upsell__btn--loading');
    const originalText = btn.textContent;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓';
        btn.classList.remove('kore-upsell__btn--loading');
        btn.classList.add('kore-upsell__btn--added');
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('kore-upsell__btn--added');
        }, 1800);

        // Refresh cart
        koreRefreshCart();
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.classList.remove('kore-upsell__btn--loading');
      });
  });

  function koreRefreshCart() {
    // Open cart drawer if it exists
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.cart_url + '?sections=cart-drawer' : '/cart?sections=cart-drawer', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          const html = sections['cart-drawer'];
          if (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Update cart items
            const newItems = doc.getElementById('CartDrawer-CartItems');
            const oldItems = document.getElementById('CartDrawer-CartItems');
            if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;

            // Update bubble
            const bubbles = doc.querySelectorAll('.cart-count-bubble');
            document.querySelectorAll('.cart-count-bubble').forEach(function (el, i) {
              if (bubbles[i]) el.innerHTML = bubbles[i].innerHTML;
            });

            // Update progress bar
            koreUpdateProgress();
          }
        })
        .catch(function () {});
    } else {
      // Fallback: trigger Dawn's cart update event
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      koreUpdateProgress();
    }
  }

  function koreUpdateProgress() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const count = cart.item_count;
        const target = 2;
        const pct = Math.min(count / target * 100, 100);

        const fill = document.getElementById('KoreProgressFill');
        const msg = document.getElementById('KoreProgressMsg');
        const badge = document.querySelector('.kore-progress__badge');
        const dots = document.querySelectorAll('.kore-progress__dot');

        if (fill) {
          fill.style.width = pct + '%';
          fill.dataset.items = count;
        }

        if (msg) {
          if (count === 0) {
            msg.textContent = 'הוסיפו מוצרים לעגלה והתחילו לפתוח הטבות';
          } else if (count < target) {
            const need = target - count;
            msg.textContent = 'עוד ' + (need === 1 ? 'מוצר אחד' : need + ' מוצרים') + ' ואתם פותחים 10% הנחה';
          } else {
            msg.textContent = 'פתחתם את ההטבה 🎉';
          }
        }

        if (badge) {
          if (count >= target) {
            badge.textContent = '🔓 נפתח';
            badge.classList.add('kore-progress__badge--unlocked');
          } else {
            badge.textContent = '🔒 10% הנחה';
            badge.classList.remove('kore-progress__badge--unlocked');
          }
        }

        // Update milestone dots
        dots.forEach(function (dot, i) {
          if (count > i) {
            dot.classList.add('is-reached');
          } else {
            dot.classList.remove('is-reached');
          }
        });
      })
      .catch(function () {});
  }

  // Listen for Dawn cart events
  document.addEventListener('cart:refresh', koreUpdateProgress);
  document.addEventListener('cart:updated', koreUpdateProgress);

  // Initial update on page load
  koreUpdateProgress();
})();
